import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

/**
 * Route guard. In a normal build it delegates to MsalGuard (interactive login).
 * In an e2e build it short-circuits to allow navigation, since the SPA runs
 * against the API's test-auth scheme and there is no MSAL session to satisfy.
 */
export const authGuard: CanActivateFn = (route, state) => {
  if (environment.e2e) return true;
  return inject(MsalGuard).canActivate(route, state);
};

export const authGuardChild: CanActivateChildFn = (route, state) => {
  if (environment.e2e) return true;
  return inject(MsalGuard).canActivateChild(route, state);
};
